<template>
  <div>
    <h1 class="title">PANTALLA {{ numeroPantalla }} AJUSTES NIVEL</h1>
    <HmiPantalla>
      <div class="content">
        <div class="screen-title">
          <HmiLabel
            label="AJUSTES NIVEL"
            width="100%"
            height="100%"
            :size="4"
            color="cyan"
            border="solid 6px yellow"
          ></HmiLabel>
        </div>
        <div class="grid">
          <div class="column">
            <div class="custom-row">
              <HmiLabel
                label="NIVEL COMPUERTA"
                width="50%"
                height="100%"
                :size="1.7"
                color="cyan"
              ></HmiLabel>
              <HmiLabel
                :label="formatoCM(nivelCompuerta) + ' cm.'"
                width="50%"
                height="100%"
                :size="1.7"
                color="#C0C000"
              ></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel
                label="DIFERENCIAL REGULACION"
                width="50%"
                height="100%"
                :size="1.7"
                color="cyan"
              >
              </HmiLabel>
              <HmiLabel
                :label="formato1digito(diferencialRegulacionMaquina1)"
                width="50%"
                height="100%"
                :size="1.7"
                color="#56FF56"
                :editable="true"
                @input="escrituraDM($event, direccionVariables.DIFERENCIAL_REGULACION_MAQUINA1_ESCRITURA, 1)"
              ></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel
                label="TIEMPO DETECCION NIVEL d/seg."
                width="50%"
                height="100%"
                :size="1.7"
                color="cyan"
              ></HmiLabel>
              <HmiLabel
                :label="formato3digito(tiempoDeteccionNivelAguaMaquina1)"
                width="50%"
                height="100%"
                :size="1.7"
                color="#56FF56"
                :editable="true"
                @input="escrituraDM($event, direccionVariables.TIEMPO_DETECCION_NIVEL_AGUA_MAQUINA1_ESCRITURA, 1)"
              ></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel
                label="COTA PARADA"
                width="50%"
                height="100%"
                :size="1.7"
                color="cyan"
              ></HmiLabel>
              <HmiLabel
                :label="formato3digito(cotaParadaMaquina1)"
                width="50%"
                height="100%"
                :size="1.7"
                color="#56FF56"
                :editable="true"
                @input="escrituraDM($event, direccionVariables.COTA_PARADA_MAQUINA1_ESCRITURA, 1)"
              ></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel
                label="TIEMPO ESPERA 2ºNIVEL Min."
                width="50%"
                height="100%"
                :size="1.7"
                color="cyan"
              >
              </HmiLabel>
              <HmiLabel
                :label="formato2digito(generadorTiempoEspera2NivelMinimo)"
                width="50%"
                height="100%"
                :size="1.7"
                color="#56FF56"
                :editable="true"
                @input="escrituraDM($event, direccionVariables.GENERADOR_TIEMPO_ESPERA_2_NIVEL_MINIMO_ESCRITURA, 1)"
              ></HmiLabel>
            </div>
          </div>
          <div class="column">
            <div class="custom-row">
              <HmiLabel
                label="NIVEL CAMARA CARGA"
                width="50%"
                height="100%"
                :size="1.7"
                color="cyan"
              >
              </HmiLabel>
              <HmiLabel
                :label="formatoCM(nivelCamaraCarga) + ' cm.'"
                width="50%"
                height="100%"
                :size="1.7"
                color="#00C0FF"
              ></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel
                label="COTA 2ºNIVEL"
                width="50%"
                height="100%"
                :size="1.7"
                color="cyan"
              ></HmiLabel>
              <HmiLabel
                :label="formato3digito(cota2Nivel)"
                width="50%"
                height="100%"
                :size="1.7"
                color="#56FF56"
                :editable="true"
                @input="escrituraDM($event, direccionVariables.COTA_2_NIVEL_ESCRITURA, 1)"
              ></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel
                label="COTA ARRANQUE"
                width="50%"
                height="100%"
                :size="1.7"
                color="cyan"
              ></HmiLabel>
              <HmiLabel
                :label="formato3digito(cotaArranque)"
                width="50%"
                height="100%"
                :size="1.7"
                color="#56FF56"
                :editable="true"
                @input="escrituraDM($event, direccionVariables.COTA_ARRANQUE_ESCRITURA, 1)"
              ></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel
                label="COTA REGULACION"
                width="50%"
                height="100%"
                :size="1.7"
                color="cyan"
              ></HmiLabel>
              <HmiLabel
                :label="formato3digito(cotaRegulacionMaquina1)"
                width="50%"
                height="100%"
                :size="1.7"
                color="#56FF56"
                :editable="true"
                @input="escrituraDM($event, direccionVariables.COTA_REGULACION_MAQUINA1_ESCRITURA, 1)"
              ></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiButton
                label="GRAFICOS"
                width="50%"
                height="100%"
                :size="1.7"
                color="silver"
              ></HmiButton>
              <HmiButton
                label="SALIR"
                width="50%"
                height="100%"
                :size="1.7"
                color="silver"
                @click.native="navigateToMenu"
              ></HmiButton>
            </div>
          </div>
        </div>
      </div>
    </HmiPantalla>
  </div>
</template>

<script>
import HmiLabel from "../HMI/HmiLabel.vue";
import HmiPantalla from "../HMI/HmiPantalla.vue";
import HmiButton from "../HMI/HmiButton.vue";

export default {
  name: "AjustesNivelPantalla",
  computed: {
    // Obtenemos el numero de pantalla en la que estamos trabajandos
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },

    direcciones() {
      let direcciones = [37, 4, 2, 3, "19", 49, 1, 7, 5];
      return direcciones;
    },

    direccionVariables() {
      return {
        NIVEL_COMPUERTA_LECTURA: 37, // Correspondiente a Dm84
        NIVEL_CAMARA_CARGA_LECTURA: 49, // Correspondiente a Dm122
        DIFERENCIAL_REGULACION_MAQUINA1_LECTURA: 4, // Correspondiente a Dm22
        DIFERENCIAL_REGULACION_MAQUINA1_ESCRITURA: 'Dm0022', // Correspondiente a Dm22
        TIEMPO_DETECCION_NIVEL_AGUA_MAQUINA1_LECTURA: 2, // Correspondiente a Dm20
        TIEMPO_DETECCION_NIVEL_AGUA_MAQUINA1_ESCRITURA: 'Dm0020', // Correspondiente a Dm20
        COTA_PARADA_MAQUINA1_LECTURA: 3, // Correspondiente a Dm21
        COTA_PARADA_MAQUINA1_ESCRITURA: 'Dm0021', // Correspondiente a Dm21
        GENERADOR_TIEMPO_ESPERA_2_NIVEL_MINIMO_LECTURA: 85, // Correspondiente a Dm19
        GENERADOR_TIEMPO_ESPERA_2_NIVEL_MINIMO_ESCRITURA: 'Dm0019', // Correspondiente a Dm19
        COTA_2_NIVEL_LECTURA: 1, // Correspondiente a Dm18
        COTA_2_NIVEL_ESCRITURA: 'Dm0018', // Correspondiente a Dm18
        COTA_ARRANQUE_LECTURA: 7, // Correspondiente a Dm25
        COTA_ARRANQUE_ESCRITURA: 'Dm0025', // Correspondiente a Dm25
        COTA_REGULACION_MAQUINA1_LECTURA: 5, // Correspondiente a Dm23
        COTA_REGULACION_MAQUINA1_ESCRITURA: 'Dm0023', // Correspondiente a Dm23
      };
    },

    nivelCompuerta() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.NIVEL_COMPUERTA_LECTURA
        ];
      }
      return "0000";
    },
    diferencialRegulacionMaquina1() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.DIFERENCIAL_REGULACION_MAQUINA1_LECTURA
        ];
      }
      return "0000";
    },
    tiempoDeteccionNivelAguaMaquina1() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TIEMPO_DETECCION_NIVEL_AGUA_MAQUINA1_LECTURA
        ];
      }
      return "0000";
    },
    cotaParadaMaquina1() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.COTA_PARADA_MAQUINA1_LECTURA
        ];
      }
      return "0000";
    },
    generadorTiempoEspera2NivelMinimo() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.GENERADOR_TIEMPO_ESPERA_2_NIVEL_MINIMO_LECTURA
        ];
      }
      return "0000";
    },
    nivelCamaraCarga() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.NIVEL_CAMARA_CARGA_LECTURA
        ];
      }
      return "0000";
    },
    cota2Nivel() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.COTA_2_NIVEL_LECTURA
        ];
      }
      return "0000";
    },
    cotaArranque() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.COTA_ARRANQUE_LECTURA
        ];
      }
      return "0000";
    },
    cotaRegulacionMaquina1() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.COTA_REGULACION_MAQUINA1_LECTURA
        ];
      }
      return "0000";
    },
  },
  components: {
    HmiPantalla,
    HmiLabel,
    HmiButton,
  },

  mounted() {
    //Mandar a nodered entrada
    this.mandarEntrada();
    //Cuando se cierre la ventana enviar señal
    window.addEventListener("unload", this.mandarSalida);
  },
  destroyed() {
    //Mandar a nodered salida
    this.mandarSalida();
  },

  methods: {
    // Navegación a "Menu"
    navigateToMenu() {
      this.$router.push(`/pantalla/${this.numeroPantalla}`);
    },

    // Emitir evento salida
    mandarSalida() {
      this.$emit("mandar-pagina", "pagina/salida", "8", "");
    },

    // Emitir evento entrada
    mandarEntrada() {
      this.$emit("mandar-pagina", "pagina/entrada", "8", "");
    },

    formatoCM(dato) {
      dato = dato.substring(1, 4);
      return dato;
    },

    formato1digito(dato) {
      return dato.substring(3, 4);
    },

    formato2digito(dato) {
      return dato.substring(2, 4);
    },

    formato3digito(dato) {
      return dato.substring(1, 4);
    },

    escrituraDM(value, direccion, canales) {
      direccion = direccion.substring(2);
      const payload = {
        name: "escrituraDM",
        direccion: direccion,
        valor: value.padStart(4 * canales, "0"),
      };
      this.$emit("mandar-escritura", payload);
    },
  },
};
</script>

<style scoped>
.title {
  font-family: "Courier New", Courier, monospace !important;
  text-align: center;
  margin: 20px 20px 0px 20px;
}

.content {
  height: 100%;
}

.screen-title {
  display: flex;
  justify-content: center;
  height: 15%;
}

.grid {
  height: 85%;
  display: flex;
  flex-direction: row;
  gap: clamp(1px, 2vw - 5px, 20px);
}

.custom-row {
  padding-top: clamp(1px, 2vw - 5px, 20px);
  height: 20%;
  display: flex;
  justify-content: space-between;
  gap: clamp(1px, 2vw - 5px, 20px);
}

.column {
  height: 100%;
  width: 50%;
}
</style>
